import { memo, useCallback, useMemo } from "react";
import { useApolloClient } from "@apollo/client";
import { UserSettingContext, UserSettings } from "@tecorien/mimic";
import { SetSettingDocument, SetSettingMutation, SetSettingMutationVariables, useGetUserSettingsQuery } from "generated/graphql";

export const UserSettingsProvider = memo(({ children }: any) => {
  const client = useApolloClient();

  const saveViewSettings = useCallback(async (id: string, value: any) => {
    try {
      await client.mutate<SetSettingMutation, SetSettingMutationVariables>({
        mutation: SetSettingDocument,
        variables: {
          key: id,
          value: JSON.stringify(value),
        },
      });
    } catch (e) {
      console.error(e);
    }
  }, [ client ]);

  const { data } = useGetUserSettingsQuery();

  const settings = useMemo(() => {
    return data?.settings
      ?.reduce?.((acc: any, val: any) => {
        let value;
        try {
          value = JSON.parse(val.value);
        } catch {
          value = val.value;
        }
        return {
          ...acc,
          [val.key]: value,
        };
      }, {});
  }, [ data ]);

  const value = useMemo((): UserSettings => {
    return ({
      initialized: !!settings,
      saveSetting: saveViewSettings,
      settings: settings || {},
    });
  }, [ settings, saveViewSettings ]);

  return (
    <UserSettingContext.Provider value={value}>
      {children}
    </UserSettingContext.Provider>
  );
});


export default UserSettingsProvider;
